import {
  MetricsResponse,
  OriginalMetricsResponse,
  ProcessingStepSection,
} from "@/types/chat-response";

import { ConsolidatedSteps, ProcessingStepMessage } from "../chat/types";

export const parseMetrics = (content: string): MetricsResponse => {
  const { metrics } = JSON.parse(content as string) as OriginalMetricsResponse;
  return {
    tokens: metrics["Total tokens"],
    inputTokens: metrics["Input tokens"] ?? 0,
    outputTokens: metrics["Output tokens"] ?? 0,
    time: metrics["Execution time"],
    tools: metrics["Tools used"],
    toolCounts: metrics["Tool usage counts"] ?? {},
  };
};

export const consolidateSteps = (
  result: ConsolidatedSteps,
  message: ProcessingStepMessage
): ConsolidatedSteps => {
  // Extract metrics from the "Execution Summary" section (formerly "Metrics")
  if (
    message.section === ProcessingStepSection.METRICS ||
    (message.section as string) === "Execution Summary"
  ) {
    try {
      return {
        ...result,
        metrics: parseMetrics(message.content as string),
      };
    } catch {
      // If parsing fails (not JSON), treat as a regular step
    }
  }

  const { steps } = result;

  // Check the first step.
  const mostRecentStep = steps[0];

  // If it doesn't exist or the incoming message is from a different section,
  // make the incoming message the most recent step.
  if (!mostRecentStep || mostRecentStep.section !== message.section) {
    result.steps.unshift({
      ...message,
      messages: [message.content as string],
    });
    return result;
  }

  const updatedSteps = [...steps];
  updatedSteps[0] = {
    ...mostRecentStep,
    timestamp: message.timestamp,
    messages: [...mostRecentStep.messages, message.content as string],
  };

  return { ...result, steps: updatedSteps };
};
